export const seoDefaults = {
    siteName: "Likengale",
    defaultTitle: "Likengale",
    defaultDescription: "…",
    defaultImage: "/og/default.jpg",
};
